import { computed, Injectable, type Signal, signal } from '@angular/core';

import type { DomainPlace } from './domain-place.model';

@Injectable({ providedIn: 'root' })
export class DomainPlaceStore {
	private readonly registeredSource = signal<Signal<DomainPlace | null> | null>(null);

	public readonly place: Signal<DomainPlace | null> = computed(() => this.registeredSource()?.() ?? null);

	public register(source: Signal<DomainPlace | null>): void {
		this.registeredSource.set(source);
	}

	public unregister(): void {
		this.registeredSource.set(null);
	}
}
